export const environment = {
  /**
   * Use same-origin API calls.
   *
   * - `ng serve` proxies `/api` to backend via `proxy.conf.json`.
   * - SSR/container runtime proxies `/api` via `src/server.ts`.
   */
  apiBaseUrl: '',
};
